import { Action } from '@ngrx/store';
import {
  DisneyPlusWebTokenResource,
  TechnicalError,
} from '@dch/products-business-logic';

export const GET_DISNEY_PLUS_WEB_TOKEN = 'GET_DISNEY_PLUS_WEB_TOKEN';
export const GET_DISNEY_PLUS_WEB_TOKEN_SUCCESS =
  'GET_DISNEY_PLUS_WEB_TOKEN_SUCCESS';
export const GET_DISNEY_PLUS_WEB_TOKEN_FAILED =
  'GET_DISNEY_PLUS_WEB_TOKEN_FAILED';

export class GetDisneyWebToken implements Action {
  type = GET_DISNEY_PLUS_WEB_TOKEN;

  constructor(public payload?: any) {}
}

export class GetDisneyWebTokenSuccess implements Action {
  type = GET_DISNEY_PLUS_WEB_TOKEN_SUCCESS;

  constructor(public payload: DisneyPlusWebTokenResource) {}
}

export class GetDisneyPlusWebTokenFailed implements Action {
  type = GET_DISNEY_PLUS_WEB_TOKEN_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetDisneyWebToken
  | GetDisneyWebTokenSuccess
  | GetDisneyPlusWebTokenFailed;
